import styled from 'styled-components'
import {NextIcon, Strong, Paragraph, media as _media, Row} from '@modifi/ui'
import {airBlue, semiDarkGray, lightGray} from '@modifi/colors'

type mediaType = Record<string, any>

const media = _media as mediaType

type propType = {
  expandItem: boolean
}
export const DisclosureWidget = styled(NextIcon)`
  transform: ${(props: propType): string =>
    props.expandItem ? 'rotate(-90deg)' : 'rotate(90deg)'};
  transition-duration: 0.2s;
  margin-left: 10px;
`

export const Anchor = styled.a`
  color: ${airBlue};
  text-decoration: none;
`

export const FAQWrapper = styled.div`
  &:last-child {
    hr {
      display: none;
    }
  }
`
type QuestionTextType = {
  isOpen: boolean
}

export const QuestionText = styled(Strong)<QuestionTextType>`
  color: ${({isOpen}): string => (isOpen ? airBlue : semiDarkGray)};
  cursor: pointer;

  &:hover {
    color: ${airBlue};
  }
`

export const AnswerWrapper = styled.div`
  margin-bottom: 16px;
  ${media.md`
    margin-bottom: 24px;
  `}
`

export const StyledParagraph = styled(Paragraph)`
  color: ${semiDarkGray};
  margin-top: 0;
`
export const StyledHr = styled.hr`
  margin-top: 0;
  margin-bottom: 0;
  border-top: 1px solid ${lightGray};
`

export const QuestionRow = styled(Row)`
  cursor: pointer;
`
